import VideoMatrise, { type Props } from '@helsenorge/core-cms/videomatrise';
import type { VimeoSubtitleLanguageCodes } from '@helsenorge/core-cms/videospiller/constants';

export interface VideoMatriseBlockProps extends Props {
  subtitleLanguageCode: VimeoSubtitleLanguageCodes;
}

const VideoMatriseBlock: React.FunctionComponent<VideoMatriseBlockProps> = ({ subtitleLanguageCode, ...rest }) => (
  <VideoMatrise subtitleLanguageCode={subtitleLanguageCode} {...rest} />
);

export default VideoMatriseBlock;
